import type { ContentProducerArea } from '~/types/modules/contents';

export const perseAreasDataToJson = (areas: string | undefined): ContentProducerArea[] => {
  try {
    return !areas ? [] : JSON.parse(areas);
  } catch {
    return [];
  }
};
